import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Role } from '../common/models/role';
import {FILE_VALIDATION_MESSAGE, NO_RECORDS, EXCHANGERATEUPLOAD, EXCHANGERATECOLUMNS } from '../common/constants/labels';
import { IncidentUploadSqlService } from '../incident-upload-SQL/incident-upload-sql.service';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CurrencyList } from '../common/models/incident-dashboard-filterparameterdata';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-currencyexchange',
    templateUrl: './currency-exchangerate.component.html',
    styleUrls: ['./currency-exchangerate.component.scss']
  })
  // Component loads the incident data upload screen
  export class CurrencyExchangeRateComponent implements OnInit {
    title = 'Exchange Rate';
    isActiveDiv = false;
    loading = true;
    showFileValidation = false;
    role;
    exchangeRateUpload = EXCHANGERATEUPLOAD;
    showSuccess = false;
    noRecordsShow = false;
    showProgress = false;
    currencyfileToUpload: File = null;
    fileValidationMsg = FILE_VALIDATION_MESSAGE;
    progressValue = 0;
    private currencyrxUnsubscribe: Subject<void> = new Subject<void>();
    currencyList: Array<CurrencyList> = [];
    @ViewChild('currencyfiles', { static: false }) myCurrencyInputVariable: ElementRef;
    recordInserted = '';
    uploadinserted = '';
    uploadrejected = '';
    uploadduplicated = '';
    displayedColumns: any;
    @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
    dataSource!: MatTableDataSource<any>;
    constructor(private incidentservice: IncidentUploadSqlService) {
    }
    ngOnInit() {
      this.loading = true;
      this.role = localStorage.getItem('role');
      if (this.role === Role.globalAdmin) {
        this.isActiveDiv = true;
      } else if (this.role === Role.qualityGlobalRead) {
        this.isActiveDiv = false;
      }
      this.displayedColumns = EXCHANGERATECOLUMNS;
      this.getCurrencyList();
      this.loading = false;
    }

    confirmation() {
      if (window.confirm('Are sure you want to upload currency exchange rate?')) {
        return true;
      }
      return false;
    }

     // method for uploading file
  uploadCurrencyExchangeRate(currencyfiles: File) {
    this.showFileValidation = false;
    this.currencyfileToUpload = currencyfiles[0];
    const currencyfileName = currencyfiles[0].name;
    if ((!currencyfileName.endsWith('.xlsx')) && (!currencyfileName.endsWith('.xls')) && (!currencyfileName.endsWith('.xlsm'))
      && (!currencyfileName.endsWith('.xlsb')) && (!currencyfileName.endsWith('.csv'))) {
      this.fileValidationMsg = FILE_VALIDATION_MESSAGE;
      this.showFileValidation = true;
      this.loading = false;
    } else {
      this.incidentservice.postFile(this.currencyfileToUpload, 'CURRENCYUPLOAD', 'CURRENCYUPLOAD', 'CURRENCYUPLOAD', 'CURRENCYUPLOAD').pipe(takeUntil(this.currencyrxUnsubscribe))
        .subscribe((event: HttpEvent<any>) => {
          if (event.type === 0) {
            this.progressValue = 25;
            this.showProgress = true;
          }
          if (event.type === 1) {
            this.progressValue = 50;
            this.showProgress = true;
          }
          if (event.type === 2) {
            this.progressValue = 75;
            this.showProgress = true;
          }
          if (event.type === 3) {
            this.progressValue = 100;
            setTimeout(() => {
              this.getCurrencyList();
              this.showProgress = false;
            }, 1000);
          }
          if (event.type === 4) {
            if (event instanceof HttpResponse) {
              this.fileValidationMsg = event.body.errorMessage;
              if (this.fileValidationMsg !== '' && this.fileValidationMsg !== null && this.fileValidationMsg !== undefined) {
                this.showFileValidation = true;
              }
              this.recordInserted = event.body.totalRowsInserted;
              if (this.recordInserted != null) {
                this.uploadinserted = 'Number of records uploaded : ' + this.recordInserted;
                this.uploadrejected = '';
                this.uploadduplicated = '';
                this.showSuccess = true;
              }
              setTimeout(() => {
                this.loading = false;
                this.showSuccess = false;
              }, 5000);
            }
          }
        }, (error) => {
          this.fileValidationMsg = 'Failed to upload currency exchange rate. Please try again after sometime.';
          this.showFileValidation = true;
          this.loading = false;
          this.showProgress = false;
          this.showSuccess = false;
        });
    }
    this.myCurrencyInputVariable.nativeElement.value = '';
    // this.loading = false;
  }

  getCurrencyList() {
    this.incidentservice.getCurrency().subscribe((response) => {
      if (response.length > 0) {
        const currencyArray = [];
        response.forEach((e) => {
          let object = {};
          object = {
            currencyunit: e.currencyunit,
            site: e.site,
            currencycode: e.currencycode,
            cluster: e.cluster,
            country: e.country,
            euroexchangerate: e.euroexchangerate
          };
          currencyArray.push(object);
        });
        this.currencyList = currencyArray;
        this.dataSource = new MatTableDataSource(this.currencyList);
        this.dataSource.paginator = this.paginator;
      }
    }, (error) => {
      this.fileValidationMsg = 'Failed to get the currency exchange rate. Please try again after sometime.';
      this.showFileValidation = true;
      this.loading = false;
      this.showProgress = false;
      this.showSuccess = false;
    });
  }
      // Authorization
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.qualityManager || this.role === Role.qualityEngineer || this.role === Role.globalAdmin || this.role === Role.ITSupport) {
      return true;
    } else {
      return false;
    }
  }
  }
